var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"prizeshare-box"},[_c('div',{staticClass:"join-box"},[_c('button',{staticClass:"join-btn",on:{"click":_vm.handleJoin}},[_vm._v("我要参加")])]),_c('div',{staticClass:"rule-box"},[_c('rule-list')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }